import { EtatAbsencesEnum } from "../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { AbsenceStateEnum, IAbsenceStyle } from "../shared/interfaces/calendar.interface";

export const typeAbsenceIcon = {
	"JCONG": "ri-sun-line", // Congés payés
	"JRECU": "ri-suitcase-2-line", // RTT,
	"HCSS": "conge", // icon non présent dans remix donc icon custom // Congé sans solde
	"JFORM": "ri-graduation-cap-line", // Formation, stage
	"JTELE": "ri-home-office-line", // Télétravail
	"DEFAULT": "ri-calendar-line", // Type par défaut
};

/**
 * Mapping des états de l'enum backend vers les états simplifiés
 */
export const etatMapping: { [key: number]: AbsenceStateEnum } = {
	[EtatAbsencesEnum.Valide]: AbsenceStateEnum.Validated,
	[EtatAbsencesEnum.Calcule]: AbsenceStateEnum.Validated,
	[EtatAbsencesEnum.Cloture]: AbsenceStateEnum.Validated,
	[EtatAbsencesEnum.EnAttenteValidationGestionnaire]: AbsenceStateEnum.PendingValidation,
	[EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1]: AbsenceStateEnum.PendingValidation,
	[EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2]: AbsenceStateEnum.PendingValidation,
	[EtatAbsencesEnum.EnAttenteAnnulationGestionnaire]: AbsenceStateEnum.PendingCancellation,
	[EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1]: AbsenceStateEnum.PendingCancellation,
	[EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2]: AbsenceStateEnum.PendingCancellation,
};

/**
 * Labels et icônes par état
 */
export const stateLabels: { [key in AbsenceStateEnum]: { title: string; icon: string } } = {
	[AbsenceStateEnum.Validated]: {
		title: "Validé",
		icon: "ri-check-line"
	},
	[AbsenceStateEnum.PendingValidation]: {
		title: "En attente de validation",
		icon: "ri-time-line"
	},
	[AbsenceStateEnum.PendingCancellation]: {
		title: "En attente d'annulation",
		icon: "ri-time-line"
	}
};



// WEBPACK FOOTER //
// ./src/config/planningMensuel.config.ts